import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { useAuth } from "../context/AuthContext"; // ✅ Import the useAuth hook

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth(); // ✅ Use login function from context

  const validateForm = () => {
    if (!email || !password) {
      swal({
        text: "Please fill in both email and password",
        icon: "warning",
      });
      return false;
    }
    return true;
  };

  async function loginUser() {
    if (!validateForm()) return;

    let item = { email, password };

    try {
      let result = await fetch("https://api.bytlas.com/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      result = await result.json();

      if (result.success) {
        swal({
          text: "Login successful!",
          icon: "success",
        });
        localStorage.setItem("user-info", JSON.stringify(result.data));
        navigate("/dashboard");
        login(result.data); // ✅ Call the login function from context
      } else {
        swal({
          text: result.message || "Login failed. Please check your credentials.",
          icon: "error",
        });
      }
    } catch (error) {
      swal({
        text: "Something went wrong. Please try again later.",
        icon: "error",
      });
      console.error("Login error", error);
    }
  }

  return (
    <div>
      <div className="container shadow my-5">
        <div style={{ marginTop: "4rem" }} className="row">
          <div className="col-md-5 d-flex flex-column align-items-center text-white justify-content-center form">
            <h1 className="display-4 fw-bolder">Welcome Back</h1>
            <p className="lead text-center">Enter Your Credentials to Login</p>
            <h5 className="mb-4">OR</h5>
            <NavLink to="/register" className="btn btn-outline-light rounded-pill pb-2 w-50">
              Sign In
            </NavLink>
          </div>
          <div className="col-md-6 p-5">
            <h1 className="display-6 fw-bolder mb-5">LOGIN</h1>
            <div>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
                <div id="emailHelp" className="form-text">
                  We'll never share your email with anyone else.
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </div>
              <button
                type="submit"
                onClick={loginUser}
                className="btn btn-primary w-100 mt-4 rounded-pill"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
